// Central API helper. Uses REACT_APP_BACKEND_URL from env; routes MUST be prefixed with /api.
const API_BASE = process.env.REACT_APP_BACKEND_URL;

async function _handle(res) {
  if (!res.ok) {
    let detail = "erro_desconhecido";
    try {
      const j = await res.json();
      detail = j.detail || detail;
    } catch (_) {
      // ignore JSON parse errors
    }
    const err = new Error(detail);
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return res.json();
}

/**
 * Submit a MACD Connect masterclass registration.
 * Returns { ...lead, resume?: "created" | "already_paid" | "pix_active" | "generate_new_pix" }.
 * Presencial edition requires ``email`` — backend enforces.
 */
export const submitMacdConnectLead = async (payload) => {
  const res = await fetch(`${API_BASE}/api/macd-connect/inscricoes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return _handle(res);
};

/**
 * Submit a LIVE OASYS ACADEMY 10/08 registration (free, no payment).
 * Returns { id, resume: "created" | "updated", source }.
 */
export const submitLiveOasysLead = async (payload) => {
  const res = await fetch(`${API_BASE}/api/live-oasys/inscricoes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return _handle(res);
};

/**
 * Read-only public config for the LIVE OASYS page.
 * Returns { live_url: string | null }.
 */
export const getLiveOasysConfig = async () => {
  const res = await fetch(`${API_BASE}/api/live-oasys/config`);
  return _handle(res);
};

/**
 * Create (or resume) the PIX charge for a lead already saved in the backend.
 * Returns { order_id, amount, payment_status, qr_code, qr_code_base64, date_of_expiration }.
 */
export const createMacdConnectPix = async ({ lead_id }) => {
  const res = await fetch(`${API_BASE}/api/macd-connect/pagamento/pix`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ lead_id }),
  });
  return _handle(res);
};

/**
 * Poll payment status for a lead. Returns { payment_status, payment_paid_at?, pix_expiration_at? }.
 */
export const getMacdConnectPagamentoStatus = async (lead_id) => {
  const res = await fetch(
    `${API_BASE}/api/macd-connect/pagamento/${encodeURIComponent(lead_id)}/status`,
    { method: "GET" },
  );
  return _handle(res);
};
